import { configureStore } from '@reduxjs/toolkit';
import { pdfSlice } from './slices/function/pdf';
import {
  approvalLoadingSlice,
  timesheetLoadingSlice,
} from './slices/function/timesheetLoaderSlice';
import { timesheetApprovalBenefitCodeSlice } from './slices/timesheet/timesheetApprovalDetails/timesheetApprovalBenefitCodes';
import { timesheetApprovalHasChangesSlice } from './slices/timesheet/timesheetApprovalDetails/timesheetApprovalHasChangesSlice';
import { timesheetApprovalServicesSlice } from './slices/timesheet/timesheetApprovalDetails/timesheetApprovalServices';
import { timesheetBonusCodeSlice } from './slices/timesheet/timesheetBonusCodes';
import { timesheetTabsSlice } from './slices/function/sideBar-filterTabSlice';
import { timesheetModalSlice } from './slices/timesheet/timesheetModalSlice';
import { timesheetNoApprovalModalSlice } from './slices/timesheet/timesheetModalSlice';
import { timesheetDetailsSlice } from './slices/timesheet/timesheetDetailSlice';
import { timesheetPageDetailSlice } from './slices/timesheet/timesheetPageDetailSlice';
import { timesheetPageSlice } from './slices/timesheet/timesheetPageSlice';
import { timesheetApprovalFeedbackDetailsSlice } from './slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsFeedbackSlice';
import { timesheetApprovalDetailsAcceptSlice } from './slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsSlice';
import { timesheetApprovalDetailsRejectSlice } from './slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsSlice';
import { timesheetApprovalDetailsVerificationSlice } from './slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsVerificationSlice';
import { timesheetDetailsWorkTimesErrorSlice } from './slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsVerificationSlice';
import { timesheetDetailsRegistryKmsErrorSlice } from './slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsVerificationSlice';
import { timesheetDetailsRegistryTimesErrorSlice } from './slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsVerificationSlice';
import { driversApi } from './api/timesheet/timesheetDriversApi';
import { branchesApi } from './api/timesheet/timesheetBranchesApi';
import { benefitCodesApi } from './api/timesheet/timesheetBenefitCodesApi';
import { workTypesApi } from './api/timesheet/timesheetWorkTypesApi';
import { timesheetApi } from './api/timesheet/timesheetApi';
import { timesheetDetailApi } from './api/timesheet/timesheetDetailApi';
import { timesheetMessageTemplatesApi } from './api/timesheet/timesheetMessageTemplatesApi';
import { timesheetCompanyGratificationApi } from './api/timesheet/timesheetCompanyGratificationApi';
import { timesheetCompanyGratificationParamsApi } from './api/timesheet/timesheetCompanyGratificationApi';
import { availabilityApi } from './api/timesheet/availabilityApi';
import { availabilitySlice } from './slices/timesheet/availabilitySlice';
import { massApprovalApi } from './slices/timesheet/massApprovalSlice';
import { massApprovalProgressReducer } from './slices/timesheet/massApprovalSlice';

export const timesheetStore = configureStore({
  reducer: {
    [timesheetBonusCodeSlice.reducerPath]: timesheetBonusCodeSlice.reducer,
    [pdfSlice.reducerPath]: pdfSlice.reducer,
    [approvalLoadingSlice.reducerPath]: approvalLoadingSlice.reducer,
    [timesheetLoadingSlice.reducerPath]: timesheetLoadingSlice.reducer,
    [timesheetApprovalBenefitCodeSlice.reducerPath]:
      timesheetApprovalBenefitCodeSlice.reducer,
    [timesheetApprovalHasChangesSlice.reducerPath]:
      timesheetApprovalHasChangesSlice.reducer,
    [timesheetApprovalServicesSlice.reducerPath]:
      timesheetApprovalServicesSlice.reducer,
    [timesheetTabsSlice.reducerPath]: timesheetTabsSlice.reducer,
    [timesheetModalSlice.reducerPath]: timesheetModalSlice.reducer,
    [timesheetNoApprovalModalSlice.reducerPath]:
      timesheetNoApprovalModalSlice.reducer,
    [timesheetDetailsSlice.reducerPath]: timesheetDetailsSlice.reducer,
    [timesheetPageDetailSlice.reducerPath]: timesheetPageDetailSlice.reducer,
    [timesheetPageSlice.reducerPath]: timesheetPageSlice.reducer,
    [timesheetApprovalFeedbackDetailsSlice.reducerPath]:
      timesheetApprovalFeedbackDetailsSlice.reducer,
    [timesheetApprovalDetailsAcceptSlice.reducerPath]:
      timesheetApprovalDetailsAcceptSlice.reducer,
    [timesheetApprovalDetailsRejectSlice.reducerPath]:
      timesheetApprovalDetailsRejectSlice.reducer,
    [timesheetApprovalDetailsVerificationSlice.reducerPath]:
      timesheetApprovalDetailsVerificationSlice.reducer,
    [timesheetDetailsWorkTimesErrorSlice.reducerPath]:
      timesheetDetailsWorkTimesErrorSlice.reducer,
    [timesheetDetailsRegistryKmsErrorSlice.reducerPath]:
      timesheetDetailsRegistryKmsErrorSlice.reducer,
    [timesheetDetailsRegistryTimesErrorSlice.reducerPath]:
      timesheetDetailsRegistryTimesErrorSlice.reducer,
    [driversApi.reducerPath]: driversApi.reducer,
    [branchesApi.reducerPath]: branchesApi.reducer,
    [benefitCodesApi.reducerPath]: benefitCodesApi.reducer,
    [workTypesApi.reducerPath]: workTypesApi.reducer,
    [timesheetApi.reducerPath]: timesheetApi.reducer,
    [timesheetDetailApi.reducerPath]: timesheetDetailApi.reducer,
    [timesheetMessageTemplatesApi.reducerPath]:
      timesheetMessageTemplatesApi.reducer,
    [timesheetCompanyGratificationApi.reducerPath]:
      timesheetCompanyGratificationApi.reducer,
    [timesheetCompanyGratificationParamsApi.reducerPath]:
      timesheetCompanyGratificationParamsApi.reducer,
    [availabilityApi.reducerPath]: availabilityApi.reducer,
    [availabilitySlice.reducerPath]: availabilitySlice.reducer,
    [massApprovalApi.reducerPath]: massApprovalApi.reducer,
    massApprovalProgress: massApprovalProgressReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      driversApi.middleware,
      branchesApi.middleware,
      benefitCodesApi.middleware,
      workTypesApi.middleware,
      timesheetApi.middleware,
      timesheetDetailApi.middleware,
      timesheetMessageTemplatesApi.middleware,
      timesheetCompanyGratificationApi.middleware,
      timesheetCompanyGratificationParamsApi.middleware,
      availabilityApi.middleware,
      massApprovalApi.middleware,
    ),
});

export type TimesheetStoreState = ReturnType<typeof timesheetStore.getState>;
export type TimesheetStoreDispatch = typeof timesheetStore.dispatch;
